import script from "./ScrollTopBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollTopBtn.vue?vue&type=script&setup=true&lang=js"

import "./ScrollTopBtn.vue?vue&type=style&index=0&id=5925d541&lang=scss"

const __exports__ = script;

export default __exports__